// extracted by mini-css-extract-plugin
module.exports =  {"title":"application_card_header-module_title_efcea","titleValue":"application_card_header-module_titleValue_cecfe","subTitle":"application_card_header-module_subTitle_f042e"};